import Card from "./Card";
import HouseholdIcon from "../HouseholdIcon";
import PropTypes from "prop-types";
import React from 'react';
import {connect} from "react-redux";
import {createDeleteEntityHandler} from "../utils/createDeleteEntityHandler";
import {sharedPortalHouseholds} from "../../../ducks";

const HouseholdCard = ({household, deleteHousehold}) => {
  return (
    <Card
      icon={() => (<HouseholdIcon/>)}
      editLink={`/households/${household.id}`}
      onDelete={() => deleteHousehold(household)}
    >
      <p>
        {household.address_1}<br/>
        {household.address_2 && <React.Fragment>{household.address_2}<br/></React.Fragment>}
        {household.city && <React.Fragment>{household.city},{' '}</React.Fragment>}
        {household.state && <React.Fragment>{household.state}{' '}</React.Fragment>}
        {household.zip}
        <br/>
        {household.country}
      </p>
    </Card>
  );
};

HouseholdCard.propTypes = {
  household: PropTypes.shape({
    address_1: PropTypes.string.isRequired,
    address_2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  deleteHousehold: createDeleteEntityHandler({
    dispatch,
    duck: sharedPortalHouseholds,
    confirmMessage: () => "Are you sure you want to delete this household?",
    successMessage: () => "Household deleted."
  })
});

export default connect(undefined, mapDispatchToProps)(HouseholdCard);
